import React, { useEffect } from 'react';
import RangeSlider from './RangeSlider';

function RangeField({ field, rangeValues, setRangeValues, updateGlobalFilter }) {
  const onRangeChange = (newRange) => {
    setRangeValues((prevRangeValues) => {
      const updatedRangeValues = { ...prevRangeValues, [field.uniqueId]: newRange };
      updateGlobalFilter(field.field, {min: newRange.min, max: newRange.max, start: field.fields_range.start, end: field.fields_range.end});
      return updatedRangeValues;
    });
  };

  return (
    <div className="mb-6">
      <h4 className="font-bold mb-2 text-lg">{field.title}</h4>
      <RangeSlider
        min={field.fields_range.min}
        max={field.fields_range.max}
        start={field.fields_range.start}
        end={field.fields_range.end}
        append={field.fields_range.append}
        onValueChange={onRangeChange}
      />
    </div>
  );
}

export default RangeField;
